module.exports = __webpack_public_path__ + "static/media/screenshot.8d9ba971.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Device/devices/GutmannShowcasePhone/screenshot.jpg
// module id = 209
// module chunks = 0